import React from 'react';
import Block from '../../design-system/chat-blocks/Block';
import KpiTiles from './KpiTiles';
import ActivityCharts from './ActivityCharts';
import RunsTable from './RunsTable';
import { fmtCompact, fmtInt, fmtUsd, relTime } from './format';

const OverviewPanel = ({ data, windowLabel, onSelect }) => {
  const t = data.totals;
  return (
    <>
      <div className="qa-head">
        <div className="qa-head__id">
          <span className="qa-head__icon">Q</span>
          <div>
            <h1 className="qa-head__title">All customers</h1>
            <div className="qa-head__sub">Staff accounts excluded · last {windowLabel}</div>
          </div>
        </div>
      </div>
      <KpiTiles tiles={[
        { key: 'orgs', label: 'Organizations', value: fmtInt(t.organizations), icon: 'building-2' },
        { key: 'users', label: 'Users', value: fmtInt(t.users), sub: `${fmtInt(t.users_active_window)} active in ${windowLabel}`, icon: 'users' },
        { key: 'analyses', label: 'Analyses', value: fmtInt(t.analyses_window), sub: `in ${windowLabel}`, icon: 'sparkles' },
        { key: 'sdk', label: 'API calls', value: fmtInt(t.sdk_jobs_window), sub: `in ${windowLabel}`, icon: 'terminal' },
        { key: 'chat', label: 'Chat messages', value: fmtInt(t.chat_messages_window), sub: `in ${windowLabel}`, icon: 'message-square' },
        { key: 'tokens', label: 'Output tokens', value: fmtCompact(t.output_tokens_window), sub: `in ${windowLabel}`, icon: 'cpu' },
        { key: 'cost', label: 'Est. cost', value: fmtUsd(t.cost_usd_window + t.gpu_cost_usd_window), sub: `LLM ${fmtUsd(t.cost_usd_window)} · GPU ${fmtUsd(t.gpu_cost_usd_window)}`, icon: 'coins' },
        { key: 'failed', label: 'Failed runs', value: fmtInt(t.failed_runs_window), sub: `in ${windowLabel}`, icon: 'alert-triangle', tone: t.failed_runs_window > 0 ? 'danger' : undefined },
      ]} />
      <ActivityCharts series={data.series} />
      <Block icon="building-2" title="Most active organizations">
        {data.top_organizations.length === 0 && <p className="qa-muted" style={{ margin: 0 }}>No organization activity in this window.</p>}
        <div className="qa-org-grid">
          {data.top_organizations.map((o) => (
            <button key={o.id} type="button" className="qa-org-card" onClick={() => onSelect({ type: 'org', id: o.id })}>
              <span className="qa-org-card__name">{o.name}</span>
              <span className="qa-org-card__meta qa-mono">{fmtInt(o.analyses_window)} analyses · {fmtInt(o.sdk_jobs_window)} API calls</span>
              <span className="qa-org-card__when">active {relTime(o.last_activity_at)}</span>
            </button>
          ))}
        </div>
      </Block>
      <RunsTable rows={data.recent_failures} title="Recent failures" icon="alert-triangle" showUser maxHeight={420} onSelectUser={(id) => onSelect({ type: 'user', id })} />
    </>
  );
};

export default OverviewPanel;
